var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GroupMini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.003c-2.48 0-4.5-2.02-4.5-4.5S5.52.003 8 .003s4.5 2.02 4.5 4.5-2.02 4.5-4.5 4.5zm0-7a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm4.66 8.5h.01a3.335 3.335 0 013.32 3.33v1.17c0 .55-.45 1-1 1s-1-.45-1-1v-1.17c0-.73-.59-1.33-1.33-1.33H3.33c-.73 0-1.33.59-1.33 1.33v1.17c0 .55-.45 1-1 1s-1-.45-1-1v-1.17c0-1.83 1.49-3.33 3.33-3.33h9.33zm1.34-3.5a2.5 2.5 0 000-5c-.55 0-1-.45-1-1s.45-1 1-1c2.48 0 4.5 2.02 4.5 4.5s-2.02 4.5-4.5 4.5c-.55 0-1-.45-1-1s.45-1 1-1zm4.67 3.5c1.83 0 3.33 1.49 3.33 3.33v1.17c0 .55-.45 1-1 1s-1-.45-1-1v-1.17c0-.73-.59-1.33-1.33-1.33H17c-.55 0-1-.45-1-1s.45-1 1-1h1.67zm.83-8.5c-.55 0-1-.45-1-1s.45-1 1-1c2.48 0 4.5 2.02 4.5 4.5s-2.02 4.5-4.5 4.5c-.55 0-1-.45-1-1s.45-1 1-1a2.5 2.5 0 000-5zm5.17 8.5c1.83 0 3.33 1.49 3.33 3.33v1.17c0 .55-.45 1-1 1s-1-.45-1-1v-1.17c0-.73-.59-1.33-1.33-1.33H23c-.55 0-1-.45-1-1s.45-1 1-1h1.67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMini);
export default __webpack_public_path__ + "static/media/GroupMini.88bffdc8d6ab10ba73fb6c397f74435f.svg";
export { ForwardRef as ReactComponent };